const ns = '[Ethos] ';

export const SET_IMAGE_CONSUMED = `${ns} consumed imageData once`;
export const EXIT_DIAGRAM = `${ns} exiting the diagram`;
